import { render, staticRenderFns } from "./LockedBalanceView.vue?vue&type=template&id=db686f20&scoped=true&"
import script from "./LockedBalanceView.vue?vue&type=script&lang=js&"
export * from "./LockedBalanceView.vue?vue&type=script&lang=js&"
import style0 from "./LockedBalanceView.vue?vue&type=style&index=0&id=db686f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db686f20",
  null
  
)

export default component.exports